/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object"

export default ($axios: any): any => ({
  // 유저 리스트
  async index(data: any) {
    return camelize(await $axios.get(`/user`, { params: snakelize(data) }))
  },

  // 로그인
  async login(data: any) {
    return camelize(
      await $axios.get(`/user/login`, {
        params: snakelize(data),
      })
    )
  },

  // 회원가입
  async store(data: any) {
    return camelize(await $axios.post(`/user`, snakelize(data)))
  },

  // 회원정보 불러오기
  async show(data: any) {
    return camelize(
      await $axios.get(`/user`, {
        params: snakelize(data),
      })
    )
  },

  // 기존회원 인증
  async getIsUserFromLegacySystem(data: any) {
    return camelize(
      await $axios.get(`/user/is_member`, {
        params: snakelize(data),
      })
    )
  },

  // 기존회원 로그인
  async loginWithLegacyAccount(data: any) {
    return camelize(
      await $axios.get(`/user/existing_member`, {
        params: snakelize(data),
      })
    )
  },

  // 포인트 자동사용 토글
  async togglePointUse(data: any) {
    return camelize(await $axios.put(`/user/point`, snakelize(data)))
  },

  // 포인트 적립 & 사용 내역 불러오기
  async getPointHistories(data: any) {
    return camelize(await $axios.get("/user/point", { params: snakelize(data) }))
  },

  // 회원가입
  async update(data: any) {
    return camelize(await $axios.put(`/user`, snakelize(data)))
  },

  // 인증번호 전송
  async sendAuthNumber(data: any) {
    return camelize(
      await $axios.get(`/user/auth_num`, {
        params: snakelize(data),
      })
    )
  },

  // 모델 지원하기
  async applyModel(data: any) {
    return camelize(await $axios.post(`/user/model`, snakelize(data)))
  },

  // 비밀번호 재설정
  async resetPassword(data: any) {
    return camelize(await $axios.post(`/user/modify_password`, snakelize(data)))
  },

  // 사용자 차단
  async block(data: any) {
    return camelize(await $axios.post(`/user/block`, snakelize(data)))
  },

  // 로그아웃
  async logout(data: any) {
    return camelize(
      await $axios.get(`/user/logout`, {
        params: snakelize(data),
      })
    )
  },

  // SNS 토큰 업데이트
  async updateSnsToken(data: any) {
    return camelize(await $axios.put(`/user/sns_token`, snakelize(data)))
  },

  // 이미지 업로드
  async uploadImage(data?: any) {
    const formData = new FormData()
    formData.append("image", data.image)
    formData.append("brand_token", data.brandToken)
    return camelize(await $axios.post("/user/images/upload", formData))
  },
})
